// import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { Component, OnInit, ViewChild, ElementRef, AfterViewInit, Inject } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { OrderService } from '../_ecomservices/order.service';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, FormControl, Validators, FormArray } from '@angular/forms';

import { NotificationService } from 'src/app/_services/notification.service';
import { LoadingService } from 'src/app/_services/loading.service';
import * as _ from 'lodash';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { OrderAssignedForDeliveryComponent } from '../order-assigned-for-delivery/order-assigned-for-delivery.component';
import { DialogService } from 'src/app/_services/dialog.service';
import { ProductService } from '../_ecomservices/product.service';

@Component({
  selector: 'app-order-edit',
  templateUrl: './order-edit.component.html',
  styleUrls: ['./order-edit.component.css']
})
export class OrderEditComponent implements OnInit {

  order_form = new FormGroup({
    id: new FormControl(null),
    customer_id: new FormControl(''),
    bill_no: new FormControl(''),
    bill_amt: new FormControl(''),
    discount_amt: new FormControl(''),
    tax_total: new FormControl(''),
    shipping_total: new FormControl(''),
    r_off: new FormControl(''),
    net_amt: new FormControl(''),
    pay_amt: new FormControl(''),
    paid_amt: new FormControl(''),
    note: new FormControl(''),
    order_date: new FormControl(''),
    status: new FormControl(''),
    order_status: new FormControl('', [Validators.required]),
    shipping_status: new FormControl(''),
    coupon_code: new FormControl(''),
    created_at: new FormControl(''),
  });

  saleProductList: any;
  filteredProducts: any;
  // crate_hint: any = 0;
  @ViewChild("ItemCode") _itemCode: ElementRef;
  @ViewChild("Qty") _quantity: ElementRef;
  productForm = new FormGroup({
    ItemCode: new FormControl('', Validators.required),
    ItemId: new FormControl('', Validators.required),
    Qty: new FormControl('', [Validators.required, Validators.min(0)]),
    Crate: new FormControl('', [Validators.required, Validators.min(0)]),
    Price: new FormControl('', [Validators.required, Validators.min(0)]),
    SubTotal: new FormControl('', Validators.required),
  });

  order_status_list: any = [];
  order_data: any = null;
  order_item_list: any = [];
  order_id: any = 0;

  isAddOrderItem: boolean = false;
  isEditOrderItem: boolean = false;
  isEditItemOnly: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private dialogService: DialogService,
    private route: ActivatedRoute,
    private titleService: Title,
    private dialogRef: MatDialogRef<OrderAssignedForDeliveryComponent>,
    private loading: LoadingService,
    private notificationService: NotificationService,
    private productService: ProductService,
    public orderService: OrderService) {
    if (data.order_id) {
      this.isEditOrderItem = true;
      this.order_id = data.order_id;
      this.isEditItemOnly = data.isEditItemOnly;
    }
  }

  ngOnInit() {
    this.titleService.setTitle('Order Details');
    this.route.paramMap.subscribe(params => {
      if (params.get('id')) {
        this.order_id = params.get('id');
      }
    });
    this.loadOrderDetails(this.order_id);
    this.onBindSalehProduct();
  }

  loadOrderDetails(order_id) {
    var result = this.orderService.get_order_details(order_id).subscribe(data => {
      console.log(data);
      if (data['status']) {
        this.order_status_list = data['order_status_list'];
        this.order_data = data['order_data'];
        data['order_data'].order_status = Number(data['order_data'].order_status);
        this.order_form.setValue(_.omit(data['order_data'], 'company_id', 'shipping_info', 'customer', 'order_items', 'pay_method_id', 'payment_method', 'order_payments', 'order_trackings', 'order_return', 'last_updated_by', 'updated_at', 'deleted_at'));

        // this.order_form.setValue(_.omit(data['order_data'], 'company_id', 'shipping_info', 'customer', 'order_items', 'pay_method_id', 'order_return', 'last_updated_by', 'updated_at', 'deleted_at'));
        this.order_item_list = data['order_data']['order_items'];
        this.order_form.controls['order_status'].setValue(data['order_data']['order_status']);
      }
      else {
        this.notificationService.error(data['error_message']);
      }
    });
  }

  onUpdateOrderStatusFormSubmit() {
    console.log(this.order_form.value)
    if (this.order_form.valid) {
      // this.loading.spin$.next(true);
      this.orderService.update_order_status(this.order_form.value).subscribe(data => {
        console.log(data);
        if (data['status']) {
          this.notificationService.success(data['message']);
          this.loading.spin$.next(false);
        }
        else {
          this.notificationService.error(data['message']);
          this.loading.spin$.next(false);
        }
      });
    }
  }

  onBindSalehProduct() {
    this.productService.get_products().subscribe(data => {
      console.log(data);
      if (data['status']) {
        this.saleProductList = data['productList'];
        console.log(this.saleProductList);
        this.loading.spin$.next(false);
      }
    });
  }

  onTypeProductName(value) {
    const filterValue = value.trim().toLowerCase();
    this.filteredProducts = this.saleProductList.filter(x => x.prod_name.toLowerCase().includes(filterValue));
  }

  onSelectProduct(itemId) {
    let product = this.saleProductList.find(x => x.id === itemId);
    //console.log(product);
    if (product) {
      this.productForm.controls['ItemId'].setValue(product.id);
      this.productForm.controls['ItemCode'].setValue(product.prod_name);
      this.productForm.controls['Price'].setValue(product.sale_price);
      this.productForm.controls['Crate'].setValue('');
      // this.crate_hint = product.CrateValue;
      // this.product_unit = product.Unit;      

      // this.itemProductsService.get_item_stock(product.ID).subscribe(data=>{
      //   if(data['status']){
      //     this.product_stock = data['stk_quantity'];
      //   }
      // });

      this._quantity.nativeElement.focus();
    }
  }

  onCalculateSubTotal() {
    let Qty = this.productForm.value.Qty || 0;
    let Price = this.productForm.value.Price || 0;
    let subTotal = (Qty * Price).toFixed(2);
    this.productForm.controls['SubTotal'].setValue(subTotal);

    // if(this.crate_hint>0)
    // {
    //   let crate = (Qty / this.crate_hint);
    //   let remender = (Qty % this.crate_hint) || 0;
    //   if(remender > 0)
    //   {
    //     crate = (crate | 0)  + 1;
    //   }
    //   this.productForm.controls['Crate'].setValue(crate);
    // }
  }

  onAddProduct() {
    if (this.productForm.valid) {
      if (this.productForm.value.Qty <= 0) {
        this.notificationService.warn('Quantity must be greater than Zero!!');
        this._quantity.nativeElement.focus();
      }
      else if (this.productForm.value.SubTotal != (this.productForm.value.Price * this.productForm.value.Qty)) {
        this.notificationService.error('Error found in price calculation!!');
      }
      else {
        let product_row = this.saleProductList.find(x => x.id === this.productForm.value.ItemId);
        if (!product_row) {
          this.notificationService.error('Unable to add this product');
        }
        else {
          const dup_index = this.order_item_list.find(x => x.product_id == product_row.id);
          if (dup_index !== undefined && dup_index != -1) {
            this.notificationService.error('This product is already added!!');
            this.loading.spin$.next(false);
          }
          else {
            var product_data = {
              // order_id: this.order_data.id,
              product_id: product_row.id,
              prod_name: product_row.prod_name,
              order_qty: 0,
              quantity: this.productForm.value.Qty,
              total_packet: this.productForm.value.Crate,
              price: this.productForm.value.Price,
              total_price: (this.productForm.value.Price * this.productForm.value.Qty).toFixed(2)
            };


            this.orderService.add_order_item(this.order_form.value, product_data).subscribe(data => {
              if (data['status']) {
                this.loadOrderDetails(this.order_id);
                // this.isEditOrderItem = false;
                this.productForm.reset();
                this.notificationService.success(data['message']);
              } else {
                this.notificationService.error(data['error_message']);
              }
            });
          }
        }
      }
    }
    else {
      // this._itemCode.nativeElement.focus();
    }
  }

  onRemoveProduct(id) {
    const index = this.order_item_list.findIndex(x => x.product_id === id);
    if (index !== undefined) {
      // Update Product Qty
      // this.products.splice(index, 1);
      // this.onCalculateBilling();
      this.notificationService.warn('Product removed successfully!!');
    }
  }

  onAddOrderItem() {
    this.isAddOrderItem = true;
    this._itemCode.nativeElement.focus();
  }

  onEditOrderItem() {
    this.isEditOrderItem = true;
    console.log(this.isEditOrderItem);
  }

  onChangeItemQty(itemData) {
    console.log(itemData);
    itemData.total_price = itemData.quantity * itemData.price;
    this.calculateOrderTotal();
  }

  onUpdateOrderItems() {
    let orderId = this.order_form.value.id;
    console.log(orderId);
    console.log(this.order_item_list);
    let qtyError = false;
    let createError = false;
    this.order_item_list.forEach(element => {
      if (element.quantity === null || element.quantity === undefined || element.quantity === "" || element.quantity < 0) {
        qtyError = true;
      }
      if (element.total_packet === null || element.total_packet === undefined || element.total_packet === "" || element.total_packet < 0) {
        createError = true;
      }
    });

    if (qtyError || createError) {
      this.notificationService.warn('Invalid product quantity or crate, Please cross check this')
    }
    else {
      this.orderService.update_order_items(this.order_form.value, this.order_item_list).subscribe(data => {
        console.log(data);
        if (data['status']) {
          this.isEditOrderItem = false;
          this.notificationService.success(data['message']);
        } else {
          this.notificationService.error(data['error_message']);
        }
      })
    }
  }

  calculateOrderTotal() {
    let net_amt = this.order_item_list.reduce((total, item) => {
      return parseFloat(total) + parseFloat(item.total_price || 0);
    }, 0);
    this.order_data.net_amt = net_amt;
    this.order_form.controls['net_amt'].setValue(net_amt);
  }

  onClose() {
    let orderData = this.order_form.value;
    this.order_form.reset();
    this.dialogRef.close(orderData);
  }


}
